import {useAtom} from "jotai";
import {useTranslation} from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {Company} from "../types/domain/company";
import {selectedCompanyAtom} from "../store/filterSelectionStore";
import {useEffect} from "react";
import {useCompanies} from "../hooks/companiesHooks";

export interface CompanyFilterProps {
    allowAll?: boolean;
    disableAutoSelect?: boolean;
}

export const CompanyFilter = (props: CompanyFilterProps) => {
    const {t} = useTranslation();
    const companies = useCompanies();
    const [selectedCompany, setSelectedCompany] = useAtom(selectedCompanyAtom);

    /* eslint-disable react-hooks/rules-of-hooks */
    if (props.disableAutoSelect !== true) {
        useEffect(() => {
            if (companies.isSuccess) {
                const companyList = companies.data;
                const isSelectedInList =
                    selectedCompany !== null && companyList.some((company) => company.id === selectedCompany.id);

                if (!isSelectedInList) {
                    setSelectedCompany(companyList.length > 0 ? companyList[0] : null);
                }
            }
        }, [companies, selectedCompany, setSelectedCompany]);
    }

    /* eslint-disable @typescript-eslint/no-unsafe-assignment */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const ALL_VALUE = {id: "*", properties: {name: t("company_filter.all")}} as any;

    return (
        <Autocomplete
            clearIcon={null}
            options={
                companies.isSuccess ? (props.allowAll === true ? [ALL_VALUE, ...companies.data] : companies.data) : []
            }
            loading={companies.isSuccess}
            getOptionLabel={(option: Company) => option.properties.name}
            value={selectedCompany ?? ALL_VALUE}
            onChange={(_, newValue: Company | null) => {
                setSelectedCompany(newValue);
                if (newValue?.id === "*") {
                    setSelectedCompany(null);
                } else {
                    setSelectedCompany(newValue);
                }
            }}
            // This is needed because of the bug in Autocomplete https://github.com/mui/material-ui/issues/26492
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.properties.name}
                </li>
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label={t("company_filter.input_label")} />}
        />
    );
};
